<template>
  <!-- 一站式服务平台统计对比报表 -->
  <basic-container>
    <el-form :inline="true" class="demo-form-inline" ref="form">
      <el-form-item label="">
        <el-radio-group v-model="dateType">
          <el-radio label="year">年度</el-radio>
          <el-radio label="month">月份</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="请选择：">
        <el-date-picker
          placeholder="选择日期"
          :clearable="false"
          :type="dateType"
          :value-format="dateFormat"
          v-model="dateVal"
          style="width: 100%;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="setIframeUrl">查询</el-button>
      </el-form-item>
    </el-form>
    <iframe :src="frameSrc" ref="iframe" width="100%" frameborder="0"></iframe>
  </basic-container>
</template>

<script>
import urlSettings from '@/config/url-settings.js';
import { getStore } from '@/util/store.js';

export default {
  data() {
    return {
      dateType: 'year', // 日期类型 year-年 month-月
      dateFormat: '', // 日期格式
      dateVal: '', // 具体日期
      frameSrc: '', // 报表地址
    };
  },
  watch: {
    dateType() {
      this.dateTypeChanged();
    },
  },
  mounted() {
    this.initIframeSize();
    window.addEventListener('resize', this.initIframeSize);
    this.dateTypeChanged();
    this.setIframeUrl();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initIframeSize);
  },
  methods: {
    /* 初始化iframe窗口大小 */
    initIframeSize() {
      const iframe = this.$refs.iframe;
      const clientHeight = document.documentElement.clientHeight - 210;
      if (!iframe) return;
      iframe.style.height = `${clientHeight}px`;
    },
    /* 日期类型切换后的回调 */
    dateTypeChanged() {
      // 切换类型后将当前的日期改成当天对应的日期，并修改日期的格式
      this.dateFormat = this.dateType == 'year' ? 'yyyy' : 'yyyy-MM';
      this.dateVal = this.dayjs(new Date()).format(this.dateFormat.replace('yyyy', 'YYYY'));
    },
    /* 设置iframe地址 */
    setIframeUrl() {
      // 注意：本地运行时如果取不到urlSettings.VUE_APP_BASE_REPORT_URL，可以换成process.env.VUE_APP_BASE_REPORT_URL来调试
      let addr = urlSettings.VUE_APP_BASE_REPORT_URL;
      let userInfo = getStore({ name: 'userInfo' });
      this.frameSrc =
        addr +
        (this.dateType == 'year' ? 'YearOrderSummary.cpt' : 'MonthOrderSummary.cpt') +
        '&selectedTime=' +
        this.dateVal +
        '&tenantId=' +
        userInfo.tenant_id;
    },
  },
};
</script>

<style></style>
